(function () {
  'use strict';

  var TRANSITION_KEY = 'kfa-route-transition';
  var PREFETCH_ATTR = 'data-kfa-atelir-prefetched';
  var navigating = false;

  function isPlainPrimaryClick(event) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function toURL(value) {
    try { return new URL(value, window.location.href); } catch (error) { return null; }
  }

  function normalizedPath(url) {
    if (!url) return '';
    return url.pathname.toLowerCase().replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
  }

  function isInternalDocumentLink(link) {
    if (!link || !link.href || link.target === '_blank' || link.hasAttribute('download')) return false;

    var url = toURL(link.href);
    if (!url || url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;

    return true;
  }

  function isExcludedRoute(url) {
    if (!url) return true;
    var path = normalizedPath(url);

    return path.indexOf('/products/') === 0 ||
      path.indexOf('/cart') === 0 ||
      path.indexOf('/account') === 0 ||
      path.indexOf('/checkouts') === 0 ||
      path.indexOf('/search') === 0 ||
      path.indexOf('/collections/xposure') === 0 ||
      path.indexOf('/collections/into-the-wide-open') === 0 ||
      path.indexOf('/collections/motion-machines') === 0 ||
      path.indexOf('/collections/structure-space') === 0;
  }

  function shouldUseTransition(link) {
    if (!isInternalDocumentLink(link)) return false;

    var url = toURL(link.href);
    if (isExcludedRoute(url)) return false;

    if (link.matches('[data-kfa-liquid-link="atelir"]')) return true;

    var isAtelirPage = document.documentElement.getAttribute('data-kfa-world') === 'atelir';
    if (!isAtelirPage) return false;

    var path = normalizedPath(url);
    return path === '/' || path.indexOf('/collections/') === 0 || path.indexOf('/pages/') === 0;
  }

  function storeEnteringState() {
    try { sessionStorage.setItem(TRANSITION_KEY, 'entering'); } catch (error) {}
  }

  function clearEnteringState() {
    try { sessionStorage.removeItem(TRANSITION_KEY); } catch (error) {}
  }

  function prefetch(link) {
    if (!shouldUseTransition(link)) return;
    var url = toURL(link.href);
    if (!url) return;

    var key = url.pathname + url.search;
    var escapedKey = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/"/g, '\\"');
    if (document.querySelector('link[' + PREFETCH_ATTR + '="' + escapedKey + '"]')) return;

    var node = document.createElement('link');
    node.rel = 'prefetch';
    node.as = 'document';
    node.href = url.href;
    node.setAttribute(PREFETCH_ATTR, key);
    document.head.appendChild(node);
  }

  function revealIncomingPage() {
    var root = document.documentElement;
    if (!root.classList.contains('kfa-route-entering')) return;

    var fontReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var shortTimeout = new Promise(function (resolve) { setTimeout(resolve, 120); });

    Promise.race([fontReady, shortTimeout]).then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('kfa-route-enter-ready');

          setTimeout(function () {
            root.classList.remove('kfa-route-entering', 'kfa-route-enter-ready');
            clearEnteringState();
          }, 290);
        });
      });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || navigating || !isPlainPrimaryClick(event) || !shouldUseTransition(link)) return;

    var url = toURL(link.href);
    if (!url) return;

    event.preventDefault();
    navigating = true;
    storeEnteringState();
    document.documentElement.classList.add('kfa-route-leaving');

    /* Navigate as soon as the white veil has closed. There is no white hold
       on the current document; all loading happens behind the incoming veil. */
    setTimeout(function () {
      window.location.assign(url.href);
    }, 145);

    /* Safety reset if navigation is cancelled by the browser. */
    setTimeout(function () {
      navigating = false;
      document.documentElement.classList.remove('kfa-route-leaving');
    }, 1600);
  }, true);

  document.addEventListener('pointerover', function (event) {
    var link = event.target.closest('a[href]');
    if (link) prefetch(link);
  }, { passive: true, capture: true });

  document.addEventListener('focusin', function (event) {
    var link = event.target.closest('a[href]');
    if (link) prefetch(link);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealIncomingPage, { once: true });
  } else {
    revealIncomingPage();
  }

  window.addEventListener('pageshow', function (event) {
    navigating = false;
    document.documentElement.classList.remove('kfa-route-leaving');

    if (event.persisted) {
      document.documentElement.classList.remove('kfa-route-entering', 'kfa-route-enter-ready');
      clearEnteringState();
    } else {
      revealIncomingPage();
    }
  });
})();
